import * as notices from './notices'
import * as testDrives from './testDrives'
import * as contacts from './contacts'

export default {
  notices,
  testDrives,
  contacts
}

export * from './call'


// WEBPACK FOOTER //
// ./src/api/index.js